import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  card: {
    borderLeft: '0.5px solid #f1f1f1',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '8px 25px',
  },
  cardEven: {
    background: '#E9EBED',
    borderTop: '1px solid #c2c2d3',
    borderBottom: '1px solid #c2c2d3',
  },
  cardContainer: {
    background: '#FFFFFF',
    boxShadow: '0px 12px 26px #0000000D',
    border: '1px solid #E8E8E9',
    borderRadius: '12px',
  },
  cardTitle: {
    font: 'normal normal 600 14px Montserrat',
    color: '#707070',
    textTransform: 'uppercase',
  },
  cardValue: {
    font: 'normal normal 600 16px Montserrat',
    color: '#38485c',
    textTransform: 'uppercase',
  },
  categories: {
    background: '#FFFFFF',
    boxShadow: '0px 12px 26px #0000000D',
    borderRadius: '12px',
    padding: '32px 40px',
    marginLeft: '18px',
  },
  labelItemTree: {
    font: 'normal normal medium 16px/19px Montserrat',
    color: '#000000',
    textTransform: 'uppercase',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
}));

export default useStyles;
